<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Subjects Withdrawn Report
      </h2>

      <b-button variant="success" class="float-right" @click="download_report">Download CSV</b-button>
      <p class="tw-italic tw-text-gray-700">
        All Subjects Withdrawn from the Study
      </p>
    </b-container>

    <b-container fluid class="tw-my-5">
      <b-row>
        <b-col lg="4"></b-col>
        <b-col lg="4"></b-col>
        <b-col lg="4">

          
          <b-form-group
          label=""
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <b-table striped hover :fields="fields" :items="subjects" :filter="filter" :current-page="currentPage" :per-page="perPage">
      
    </b-table>

     <b-row v-if="totalRows > perPage">
      <b-col sm="12" md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapActions, mapState, mapGetters } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  components: {
  },
  data: function() {
    return {
      fields: [
        // { key: 'row_id' },
        { key: 'subject_id', label: 'Subject ID'},
        // { key: 'subject_name' },
        { key: 'withdrawal_request_date'},
        { key: 'withdrawal_reason', label: 'Reason'},
        { key: 'withdrawal_approval_status'},
        { key: 'withdrawal_approval_date'},
        { key: 'final_status_date'},
        { key: 'closure_date'}
      ],
      perPage: 15,
      totalRows: 1,
      currentPage: 1,
      subjects: [],
      componentKey: 0,
      filter: null,
      active_aesae_list: [],
      active_aesae_modal_title: 'AE/SAE Cases',
      report_csv_src: process.env.VUE_APP_AXIOS_BASE_URL + '/kenya/subject-final-status-report-csv'
    };
  },
  computed: {
    ...mapState("user", ["user", "myGroups"]),
    ...mapGetters('user', ['inMyGroups'])
  },
  mounted: function() {
    let that = this;
     HTTP.get("/kenya/subject-final-status-report").then(response => {
      that.subjects = response.data;
      that.totalRows = response.data.length;
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
     ...mapActions('subjectfinalstatuscompleted', 
            ['getSubjectFinalCompletedCount', 'setSubjectFinalCompletedCount']),
    refreshSideNavCount(){
      this.getSubjectFinalCompletedCount().then((response) => {
                this.setSubjectFinalCompletedCount(response.data);
            });
    },
     view_aesae_list: function(index){
      let that = this;
      that.active_aesae_list = that.subjects[index].unresolved_aesae;
      that.active_aesae_modal_title = 'AE/SAE Cases for ' + that.subjects[index].name;
    },
    final_status_approve: function(index){
      let that = this;
      HTTP.post("/kenya/subject_final_status/"+that.final_status_subjects[index].id+"/", {
        status: 'rclose'
      }).then(response => {
          that.final_status_subjects.splice(index, 1, response.data);
          that.refreshSideNavCount();
      });


    },
    download_report: function(){
      let that = this;
      HTTP.get(that.report_csv_src).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Subjects Withdrawn Report.csv');
        document.body.appendChild(fileLink);
        fileLink.click();
    }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    },
    final_status_decline: function(index){
      let that = this;
      HTTP.post("/kenya/subject_final_status/"+that.final_status_subjects[index].id+"/", {
        status: 'decline'
      }).then(response => {
          that.final_status_subjects.splice(index, 1, response.data);
          that.refreshSideNavCount();
      });
    }
  }
};
</script>

<style>
</style>